// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 643) return "js/pdfmake.js";
	if (chunkId === 297) return "js/xlsx.js";
	// return url for filenames based on template
	return undefined;
};